export default class Panel extends Phaser.GameObjects.Container {
    private bgTop!: Phaser.GameObjects.Image;
    private bgMid!: Phaser.GameObjects.Image;
    private bgBottom!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number, height: number) {
        super(scene, x, y);

        this.setupTop();
        this.setupMid(height);
        this.setupBottom();
    }

    private setupTop(): void {
        const frame = 'gui/common/popup_core/bg_body_top';

        this.bgTop = this.scene.add.image(0, 0, 'atlas', frame);
        this.bgTop.setOrigin(0.5, 0);
        this.add(this.bgTop);
    }

    private setupMid(height: number): void {
        const x = 0;
        const y = this.bgTop.displayHeight;
        const frame = 'gui/common/popup_core/bg_body_mid';

        this.bgMid = this.scene.add.image(x, y, 'atlas', frame);
        this.bgMid.setOrigin(0.5, 0);
        this.bgMid.displayHeight = height;
        this.add(this.bgMid);
    }

    private setupBottom(): void {
        const x = 0;
        const y = this.bgTop.displayHeight + this.bgMid.displayHeight;
        let frame = 'gui/common/popup_core/bg_body_bottom';

        this.bgBottom = this.scene.add.image(x, y, 'atlas', frame);
        this.bgBottom.setOrigin(0.5, 0);
        this.add(this.bgBottom);
    }

    public get totalHeight(): number {
        return this.bgTop.displayHeight + this.bgMid.displayHeight + this.bgBottom.displayHeight;
    }
}
